// ./inc/AdminFormalityActionsButtons.jsx
import React, { useEffect } from "react";
import { debug } from 'utils'
import { FiHelpCircle } from "react-icons/fi";

export default function AdminFormalityActionsButtons({
  request,
  onOpenCustomerMessage,
  onSendPaymentLink,
  onAssign,
  onMarkAsProcessed,
  onUpdateStatus,
}) {
  useEffect(() => {
  }, [request.frId])


  if (!request) {
    return null;
  }

  // -----------------------------
  // Statut : draft
  // -----------------------------
  if (request.frStatus === "draft") {
    return null;
  }

  // -----------------------------
  // Statut : pending
  // -----------------------------


  if (request.frStatus === "validated") {
    if (request.order?.orderPaymentStatus === "processing") {
      return (
        <div>
          <p className="small text-danger my-1">Paiement SEPA en cours de traitement</p>
          <div className="pb-3">
            <button
              className="btn btn-sm btn-primary"
              onClick={onAssign}
            >
              Prendre en charge cette demande
            </button>
          </div>
        </div>
      );

    }
    return null;

  }





  // -----------------------------
  // not compliant 
  // -----------------------------
  if (request.validation?.validated != true) {
    return (
      <div className="py-3">
        <div className="alert alert-danger py-1 px-2 small">
          Cette demande n'est pas conforme.<br />(Champs requis manquants)
        </div>
        {request.frIsCompliantReason?.code >= 30 && /// <30 : analyse incomplete
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => onOpenCustomerMessage("rejection")}
          >
            Informer le client
          </button>
        }
      </div>
    );
  }


  // -----------------------------
  // Statut : pending
  // -----------------------------
  if (request.frStatus === "pending") {
    return (
      <div className="py-3">
        <button
          className="btn btn-sm btn-primary"
          onClick={onAssign}
        >
          Prendre en charge cette demande
        </button>
      </div>
    );
  }
  // -----------------------------
  // not compliant 
  // -----------------------------
  if (!request.frIsCompliant) {
    return (
      request.frIsCompliantReason?.message &&
      <div className="py-3">
        <div className="alert alert-danger py-1 px-2 small">
          {request.frIsCompliantReason?.message}
        </div>
        {request.frIsCompliantReason?.code >= 30 && /// <30 : analyse incomplete
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => onOpenCustomerMessage("rejection")}
          >
            Informer le client
          </button>
        }
      </div>

    );
  }
  // -----------------------------
  // Statut : in_progress
  // -----------------------------
  if (request.frStatus === "in_progress") {
    return (
      <div className="py-3">
        <div className="alert alert-success py-1 px-2 small">
          Tous les documents ont été validés. La formalité peut être accomplie.
        </div>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => onUpdateStatus("todo")}
        >
          Indiquer que la formalité peut être accomplie
        </button>
      </div>
    );
  }
  // -----------------------------
  // Statut : todo // in_progress
  // -----------------------------
  if (['todo'].includes(request.frStatus)) {
    return (
      <div className="py-3">
        <div className="alert alert-success py-1 px-2 small">
          Tous les documents ont été validés. La formalité peut être accomplie.
        </div>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={onMarkAsProcessed}
        >
          Indiquer que la formalité a été accomplie
        </button>
      </div>
    );
  }

  // -----------------------------
  // Statut : resubmitted
  // -----------------------------
  if (request.frStatus === "resubmitted") {
    return (
      <div className="py-3">

        <div className="alert alert-success py-1 px-2 small">
          Tous les documents ont été validés. La formalité peut être accomplie.
        </div>
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={onMarkAsProcessed}
        >
          Indiquer que la demande a été accomplie
        </button>
      </div>
    );
  }


  // -----------------------------
  // Statut : todo
  // -----------------------------
  if (request.frStatus === "processed") {
    return (
      <div className="py-3">

        <div className="alert alert-info py-1 px-2 small">
          La demande a été traitée. En attente de livraison des documents au client.<br />
        </div>
        {request.response_documents && request.response_documents.length > 0 ?
          (<button
            className="btn btn-outline-info btn-sm"
            onClick={() => onOpenCustomerMessage("sendDocuments")}
          >
            Délivrer les documents au client
          </button>)
          : (
            <div className="text-danger small d-flex align-items-center gap-1">
              <em>Aucun document de réponse disponible.</em>
              <span
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title='Veuillez téléverser les documents à envoyer au demander dans la colonne de droite, onglet "Réponse".'
                style={{ cursor: "help" }}
              >
                <FiHelpCircle size={14} />
              </span>
            </div>
          )
        }

      </div>
    );
  }


  // -----------------------------
  // Statut : completed
  // -----------------------------
  if (request.frStatus === "completed") {
    return (
      <div className="py-3">
        <div className="alert alert-info py-1 px-2 small">
          La demande a été totalement traitée. Souhaitez-vous l'archiver ?
        </div>
        <button
          className="btn btn-outline-info btn-sm"
          onClick={() => onUpdateStatus("archived")}
        >
          Archiver la demande
        </button>
      </div>
    );
  }
  // -----------------------------
  // Statut : completed
  // -----------------------------
  if (request.frStatus === "archived") {
    return (
      <div className="py-3">
        <div className="text-muted py-1 px-2 small">
          Demande archivée
        </div>
      </div>
    );
  }


  return (
    <div className="py-2 small text-muted">
      Pas d'action pour
      <ul><li>frStatus : {request.frStatus}</li><li>frIsCompliant : {request.frIsCompliant ? 'true' : 'false'}</li></ul>
    </div>);
}
